<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="row">
    <div class="col-12 mb-0">
      <h4 class="mb-2 py-1 font-header-1">Case Manager</h4>
    </div>
  </div>
  <div class="row ">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pb-0 pt-2 mb-4">
          <div class="row no-gutters ">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-5 d-none d-lg-block  mt-1">
              <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#casemodalopen"
                (click)="CaseCreateupdate('new')" *ngIf="fp.casemanagercreate">Add
                Case Manager</button>&nbsp;&nbsp;
            </div>

            <div class="col text-right text-end ">
              <button type="button" class="btn btn-sm" (click)="Refresh()">
                <i class="fa fa-repeat"> </i>Refresh
              </button>&nbsp;&nbsp;
            </div>
          </div>
          <div class="row mt-2" *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
          global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
            <div class="col">
              <!-- //////////////////////////////////////////////// Ejs --- Grid//////////////////////////////////////////////////////////////////////////////////////////////////// -->
              <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
                allowPaging='true' [allowFiltering]='true' (resizeStop)="onResize($event)" [pageSettings]='initialPage'
                [filterSettings]='filterOptions' (actionBegin)="onActionComplete($event)" [showColumnChooser]='true'
                (dataStateChange)='dataStateChange($event)'>
                <e-columns>
                  <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center"
                    [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#casemodalopen"
                        *ngIf="fp.casemanagerupdate" (click)="CaseCreateupdate('edit');selectCasedetails(data)"><i
                          class="fa fa-edit"></i></button>&nbsp;

                      <button class="btn btn-delete-table" data-bs-toggle="modal" data-bs-target="#deletemodal"
                        (click)="setDeleteId(data.id)" *ngIf="fp.casemanagerdelete"><i class="fa fa-trash"></i></button>
                    </ng-template>
                    <ng-template #template let-data>
                      <input type="radio" (change)="caseemit(data)">
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="name" headerText="Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="street" headerText="Street" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="state" headerText="State" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="city" headerText="City" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="email" headerText="Email" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="zip" headerText="Zip" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>

                  <e-column minWidth=100 field="phone" headerText="Phone" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="fax" headerText="Fax" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>

                  <!--------------------------------table header icon---------------->
                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div>
                        <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ////////////////////////////////Create and Update model/////////////////////////////////// -->
<span id="opencasemanModal1" data-bs-target="#casemodalopen" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="casemodalopen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog   modal-lg-down" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ModelType =='new'"> Create Case Manager</h5>

        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ModelType =='edit'">Update Case
          Manager </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body  modal-lg">
        <div class="row" [formGroup]="CaseForm">
          <div class="col-lg-5">
            <label>Name<sup class="super-script">*</sup>
            </label>
          </div>
          <div class="col-lg-7">
            <input type="text" class="form-control" formControlName="name" [(ngModel)]="Case.name" name="name"
              (ngModelChange)="checkpopup('name')" />
          </div>
        </div>
        <span class="help-block text-danger text-center"
          *ngIf="!CaseForm.get('name').valid && CaseForm.get('name').touched">
          <p>Please Enter Name</p>
        </span>
        <div class="row">
          <div class="col-lg-5">
            <label>Street</label>
          </div>
          <div class="col-lg-7 mt-1">
            <input type="text" class="form-control" [(ngModel)]="Case.street" name="street"
              (ngModelChange)="checkpopup('street')">
          </div>
        </div>
        <div class="row" [formGroup]="CaseForm">
          <div class="col-lg-5">

            <label>Email</label>
          </div>
          <div class="col-lg-7 mt-1">

            <input type="text" class="form-control" formControlName="Email" [(ngModel)]="Case.email">
            <div class="error" *ngIf="CaseForm.controls['Email'].touched && CaseForm.controls['Email'].invalid">
              Enter Valid Email</div>

          </div>
        </div>

        <div class="row">
          <div class="col-lg-5">
            <label>State</label>
          </div>
          <div class="col-lg-7 mt-1">
            <ng-select [(ngModel)]="Case.state" [items]="stateList" class="width25" [searchable]="true"
              [clearable]="true" bindLabel="name" bindValue="abbreviation">
            </ng-select>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-5">
            <label>City</label>
          </div>
          <div class="col-lg-7 mt-1">
            <input type="text" class="form-control" [(ngModel)]="Case.city" name="city"
              (ngModelChange)="checkpopup('city')">
          </div>
        </div>

        <div class="row" [formGroup]="CaseForm">
          <div class="col-lg-5">

            <label>Zip<sup class="super-script">*</sup></label>
          </div>
          <div class="col-lg-7 mt-1">

            <input type="text" class="form-control" formControlName="zip" [(ngModel)]="Case.zip" minlength="5"
              maxlength="11" name="zip" (keypress)="numberOnly($event)">
            <div class="error" *ngIf="CaseForm.controls['zip'].touched && CaseForm.controls['zip'].invalid">
              Enter Valid Zipcode</div>
          </div>
        </div>

        <div class="row" [formGroup]="CaseForm">
          <div class="col-lg-5">

            <label>phone</label>
          </div>
          <div class="col-lg-7 mt-1">
            <input type="text" min="0" max="99999999999999" (keypress)="numberOnly($event)" maxlength="14"
              class="form-control" formControlName="phone" [(ngModel)]="Case.phone"
              (ngModelChange)="DemographicPhoneFormat('phone');checkpopup('Phone')" name="phone" />
          </div>
        </div>
        <div class="row" [formGroup]="CaseForm">
          <div class="col-lg-5">
            <label>Fax</label>
          </div>
          <div class="col-lg-7 mt-1">
            <input type="text" min="0" max="99999999999999" (keypress)="numberOnly($event)" maxlength="14"
              class="form-control" formControlName="fax" [(ngModel)]="Case.fax"
              (ngModelChange)="DemographicPhoneFormat1('fax');checkpopup('fax')" name="fax" />
          </div>
        </div>
      </div>

      <div class="modal-footer mt-4">
        <button class="btn blue-btn btn-sm" (click)="SaveOrUpdateCase('new');" *ngIf="ModelType =='new'" [disabled]="isSaveorUpdateBoolean|| CaseForm.invalid||(Case.name=='' || Case.name== undefined ||Case.zip==''
              || Case.zip== undefined || Case.zip== null)">
          Save & Close</button>
        <button class="btn blue-btn btn-sm" *ngIf="ModelType =='edit'" (click)="SaveOrUpdateCase('edit');"
          [disabled]="isSaveorUpdateBoolean || CaseForm.invalid||(Case.name=='' || Case.name== undefined ||Case.zip=='' || Case.zip== undefined)">
          Update & Close </button>
        <button type="button" class="btn  btn-sm" (click)="openDialog()">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<span id="openModal2" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" data-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Record</h5>
        <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Delete</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- ==============close without save modal================================= -->
<span id="cancelcasemanmodal" data-bs-toggle="modal" data-bs-target="#ClosecasemanModal"></span>
<div class="modal fade primarymodal modalbackgrod" id="ClosecasemanModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="closeAddUpdateModal()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>